export type MissingEntraIdCredentialsReason = 'no-cached-account' | 'no-access-token';

/** Indicates that MSAL cannot currently provide a usable Entra access token. */
export class MissingEntraIdCredentialsError extends Error {
    constructor(readonly reason: MissingEntraIdCredentialsReason) {
        super(`Entra ID credentials are unavailable: ${reason}`);
        this.name = 'MissingEntraIdCredentialsError';
    }
}

/** Indicates that the deployment's runtime Entra configuration is missing or malformed. */
export class EntraIdConfigurationError extends Error {
    constructor(readonly field: string, reason: string) {
        super(`Invalid Entra ID configuration for ${field}: ${reason}`);
        this.name = 'EntraIdConfigurationError';
    }
}

